import { render, staticRenderFns } from "./VentasToolbar.vue?vue&type=template&id=0a12a7ee&scoped=true&lang=pug"
import script from "./VentasToolbar.vue?vue&type=script&lang=js"
export * from "./VentasToolbar.vue?vue&type=script&lang=js"
import style0 from "./VentasToolbar.vue?vue&type=style&index=0&id=0a12a7ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a12a7ee",
  null
  
)

export default component.exports